var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 16.875C8.23129 16.875 0.458374 18.8292 0.458374 22.7083V25.625H23.7917V22.7083C23.7917 18.8292 16.0188 16.875 12.125 16.875Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91258 8.12501H18.3522C18.7459 8.12501 19.0667 7.80418 19.0667 7.41043V7.38126C19.0667 6.98751 18.7459 6.66668 18.3522 6.66668H17.9584C17.9584 4.50834 16.7772 2.65626 15.0417 1.63543V3.02084C15.0417 3.42918 14.7209 3.75001 14.3126 3.75001C13.9042 3.75001 13.5834 3.42918 13.5834 3.02084V1.03751C13.1167 0.920843 12.6355 0.833344 12.1251 0.833344C11.6147 0.833344 11.1334 0.920843 10.6667 1.03751V3.02084C10.6667 3.42918 10.3459 3.75001 9.93758 3.75001C9.52925 3.75001 9.20842 3.42918 9.20842 3.02084V1.63543C7.473 2.65626 6.29175 4.50834 6.29175 6.66668H5.91258C5.51883 6.66668 5.198 6.98751 5.198 7.38126V7.42501C5.198 7.80418 5.51883 8.12501 5.91258 8.12501Z",
    fill: "#6FCF97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 13.9583C14.8375 13.9583 17.0979 12.0917 17.7542 9.58334H6.49585C7.1521 12.0917 9.41252 13.9583 12.125 13.9583Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineering);
export default __webpack_public_path__ + "static/media/engineering.59fee465fdc0e2be88f796c6947e2ca9.svg";
export { ForwardRef as ReactComponent };